import { z } from "@core/zod";

import { ServiceIdSchema } from "./service.ts";
import { UserIdSchema } from "./user.ts";

export const PrincipalIdSchema = z.union([ServiceIdSchema, UserIdSchema]);

export type PrincipalId = z.infer<typeof PrincipalIdSchema>;
